import React, { FC, memo, useCallback } from 'react';
import { v4 as uuidv4 } from 'uuid';
import { DragDropContext, Droppable, DropResult } from 'react-beautiful-dnd';

import Item from '../Item';
import { ActionCard, AddButton } from './styles';
import { Props } from './types';

const Modifiers: FC<Props> = ({
  move,
  unshift,
  remove,
  items,
  isProcessing,
  brandId,
  itemsMap,
}) => {
  const handleDragEnd = useCallback(
    ({ source, destination }: DropResult) => {
      if (!destination) {
        return;
      }
      move(source.index, destination.index);
    },
    [move],
  );

  const handleAdd = useCallback(
    () =>
      unshift({
        id: uuidv4(),
        name: '',
        price: '0',
        status: 'ACTIVE',
        state: 'PROCESSING',
      }),
    [unshift],
  );

  return (
    <>
      <ActionCard>
        <AddButton type="button" onClick={handleAdd} disabled={isProcessing}>
          Add modifier
        </AddButton>
      </ActionCard>
      <DragDropContext onDragEnd={handleDragEnd}>
        <Droppable droppableId="modifiers">
          {(provided) => (
            <div {...provided.droppableProps} ref={provided.innerRef}>
              <div>
                {items.map((item, index) => (
                  <Item
                    key={item.id}
                    index={index}
                    id={item.id}
                    remove={remove}
                    isProcessing={isProcessing}
                    brandId={brandId}
                    status={itemsMap[item.id]?.status}
                    state={
                      itemsMap[item.id] ? itemsMap[item.id].state : 'PROCESSING'
                    }
                    isUpdatingStatus={itemsMap[item.id]?.isUpdatingStatus}
                  />
                ))}
              </div>
              {provided.placeholder}
            </div>
          )}
        </Droppable>
      </DragDropContext>
    </>
  );
};

export default memo(Modifiers);
